// 开发环境走本地代理（见 vue.config.js 中 devServer.proxy），生产环境直连真实域名


export default {
	// api请求地址
	baseUrl: 'https://shop.zjlonghuang.com',
	// 图片域名
	imgDomain: 'https://shop.zjlonghuang.com',
	// 腾讯地图key
	mpKey: '{{$mpKey}}',
	// 客服
	webSocket: 'wss://shop.zjlonghuang.com/wss',
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,
}